import { each, equals2, filterL, go, head, mapL, rejectL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
export const _handleTouchEndOrCancel = (self, event) => {
  if (self._touch_map.size <= 0) {
    return;
  }
  event.preventDefault();
  const { changedTouches: changed_touches, touches } = event;
  const changed_touch_map = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    mapL((touch) => [touch.identifier, touch]),
    (entries) => new Map(entries)
  );
  const touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(touches),
    mapL(({ identifier: id }) => id),
    (iter) => new Set(iter)
  );
  const prev_touch_map = self._touch_map;
  self._touch_map = go(
    self._touch_map.entries(),
    rejectL(([id]) => changed_touch_map.has(id)),
    rejectL(([id]) => !touch_id_set.has(id)),
    (entries) => new Map(entries)
  );
  switch (self._processing_task) {
    case BaseNS.PROCESSING_TASK.ZOOMING_AND_PANNING:
    case BaseNS.PROCESSING_TASK.PATH_EDITING_ZOOMING_AND_PANNING: {
      if (
        self._zooming_and_panning_touch_id1 != null &&
        self._zooming_and_panning_touch_id2 != null &&
        self._touch_map.has(self._zooming_and_panning_touch_id1) &&
        self._touch_map.has(self._zooming_and_panning_touch_id2)
      ) {
        return;
      }
      if (
        (self._zooming_and_panning_touch_id1 == null ||
          !self._touch_map.has(self._zooming_and_panning_touch_id1)) &&
        (self._zooming_and_panning_touch_id2 == null ||
          !self._touch_map.has(self._zooming_and_panning_touch_id2))
      ) {
        self._processing_task = equals2(self._processing_task)(
          BaseNS.PROCESSING_TASK.PATH_EDITING_ZOOMING_AND_PANNING
        )
          ? BaseNS.PROCESSING_TASK.PATH_EDITING
          : null;
        self._zooming_and_panning_touch_id1 = null;
        self._zooming_and_panning_touch_id2 = null;
        self._zooming_and_panning_progress_touch_x1 = 0;
        self._zooming_and_panning_progress_touch_y1 = 0;
        self._zooming_and_panning_progress_touch_x2 = 0;
        self._zooming_and_panning_progress_touch_y2 = 0;
        return;
      }
      if (
        self._zooming_and_panning_touch_id1 == null ||
        !self._touch_map.has(self._zooming_and_panning_touch_id1)
      ) {
        self._zooming_and_panning_touch_id1 = null;
      }
      if (
        self._zooming_and_panning_touch_id2 == null ||
        !self._touch_map.has(self._zooming_and_panning_touch_id2)
      ) {
        self._zooming_and_panning_touch_id2 = null;
      }
      return;
    }
    case BaseNS.PROCESSING_TASK.PATH_EDITING: {
      if (self._touch_map.size > 0) {
        return;
      }
      const touch = go(
        changed_touch_map.values(),
        filterL((touch) => prev_touch_map.has(touch.identifier)),
        head
      );
      if (touch == null) {
        return;
      }
      const { target } = touch;
      if (!(target instanceof self._window.Node)) {
        return;
      }
      const target_node = target;
      go(
        self._path_editor_list,
        mapL(({ view }) => view),
        each((view) => view.click(target_node))
      );
      return;
    }
    case BaseNS.PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING: {
      if (
        self._path_editing_touch_id != null &&
        self._touch_map.has(self._path_editing_touch_id)
      ) {
        return;
      }
      self._processing_task = BaseNS.PROCESSING_TASK.PATH_EDITING;
      self._path_editing_touch_id = null;
      self._path_editing_progress_touch_x = 0;
      self._path_editing_progress_touch_y = 0;
      return;
    }
    default: {
      return;
    }
  }
};
